<template>
  <div>
    <GenerateFloatingIp ref="GenerateFloatingIp" v-on:generateComplete="getFloatingIpData()"></GenerateFloatingIp>
    <ServerBindFloatingIp ref="ServerBindFloatingIp" v-on:bindComplete="getFloatingIpData(FloatingIp.page)"></ServerBindFloatingIp>
    <Card>
      <Row>
        <div style="float: left">
          <AllTenantSwitch ref="AllTenantSwitch" v-on:callback="getFloatingIpData()"></AllTenantSwitch>
        </div>
        <div style="float: right;">
          <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getFloatingIpData(FloatingIp.page)">刷新</Button>
          <Button
            @click="$refs.GenerateFloatingIp.openModal()"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">生成浮动IP</Button>
        </div>
      </Row>
      <Table
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="FloatingIp.data"
        :columns="FloatingIp.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ FloatingIp.data.length }} 条记录，总共 {{ FloatingIp.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="FloatingIp.count"
            :current="FloatingIp.page"
            :page-size="FloatingIp.size"
            @on-change="getFloatingIpData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudFloatingIp, deletePrivateCloudFloatingIp } from '@/api/private-cloud/floating-ip'
import { resourceIdTransName } from '@/view/private-cloud/cacheData'
import AllTenantSwitch from '@/view/private-cloud/components/allTenantSwitch'
import GenerateFloatingIp from './components/generate-floating-ip'
import ServerBindFloatingIp from './components/server-bind-floating-ip'
import moment from 'moment'

export default {
  components: {
    moment,
    GenerateFloatingIp,
    ServerBindFloatingIp,
    AllTenantSwitch
  },
  data () {
    return {
      tableLoading: false,
      FloatingIp: {
        data: [],
        columns: [
          {
            type: 'selection',
            minWidth: 60,
            align: 'center'
          },
          {
            title: '租户',
            minWidth: 130,
            align: 'center',
            key: 'project_id',
            render: (h, params) => {
              return h('span', resourceIdTransName('projects', params.row.project_id))
            }
          },
          {
            title: 'IP地址',
            align: 'center',
            minWidth: 100,
            tooltip: true,
            key: 'floating_ip_address'
          },
          {
            title: '已映射固定IP地址',
            align: 'center',
            minWidth: 150,
            tooltip: true,
            key: 'fixed_ip_address'
          },
          {
            title: '资源池(外部网络)',
            align: 'center',
            minWidth: 150,
            tooltip: true,
            key: 'floating_network_id',
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    this.$router.push({ name: 'network_detail', params: { id: params.row.floating_network_id } })
                  }
                }
              }, (params.row.floating_network_id ? resourceIdTransName('networks', params.row.floating_network_id) : '无'))
            }
          },
          {
            title: '状态',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let status = params.row.status
              let color = status === 'ACTIVE' ? 'success'
                : status === 'DOWN' ? 'warning'
                  : status === 'ERROR' ? 'error'
                    : 'warning'
              let text = status === 'ACTIVE' ? '运行'
                : status === 'DOWN' ? 'Down'
                  : status === 'ERROR' ? '错误'
                    : '未知'
              return h('Badge', {
                props: {
                  text: text,
                  status: color
                }
              })
            }
          },
          {
            title: '创建时间',
            align: 'center',
            minWidth: 200,
            key: 'created_at',
            render: (h, params) => {
              return h('span', params.row.created_at ? moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss') : '')
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              let gatewayBtn
              if (params.row.port_id) {
                gatewayBtn = h('Poptip', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要解除关联吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.$refs.ServerBindFloatingIp.unBind(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '解除关联')
                ])
              } else {
                gatewayBtn = h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.ServerBindFloatingIp.openModal(params.row.id, 'floating_ip')
                    }
                  }
                }, '关联')
              }
              return h('div', [
                gatewayBtn,
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要释放吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '释放浮动IP')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      }
    }
  },
  mounted: function () {
    this.getFloatingIpData()
  },
  methods: {
    // 获取浮动IP列表数据
    getFloatingIpData (value = 1) {
      this.FloatingIp.page = value
      let params = {
        page: this.FloatingIp.page,
        size: this.FloatingIp.size,
        all_tenants: this.$refs.AllTenantSwitch.allTenants()
      }
      this.tableLoading = true
      getPrivateCloudFloatingIp(params).then(res => {
        this.FloatingIp.data = res.data.results
        this.FloatingIp.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取浮动IP列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取浮动IP列表失败！服务器无响应'
          })
        }
      })
    },
    // 释放浮动IP
    delete (row) {
      deletePrivateCloudFloatingIp(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getFloatingIpData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
